import { createContext } from "react";
import type { UseTableColumnPreferencesResult } from "./useTableColumnPreferences";

export const DataTablePreferencesContext =
  createContext<UseTableColumnPreferencesResult<unknown> | null>(null);
